module.exports = __webpack_public_path__ + "static/media/white-logo.0e52e2fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/white-logo.png
// module id = 365
// module chunks = 0